import React from "react";

export const Ecosystem = () => {
  return (
    <div className="meet pb-5" style={{ overflow: "hidden" }}>
      <div className="container">
        <div
          className="row justify-content-center"
          data-aos="fade-up"
          data-aos-delay="500"
        >
          <div className="col-12 text-center">
            <button className="btn-gradient mb-4">Platform</button>

          </div>
        </div>

        <div className="row align-items-center resp mt-5">
          <div
            class="col-xl-6 d-flex flex-column justify-content-center aos-init aos-animate"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <div>
              <div>
                {/* <button className="btn-gradient mb-4">Platform</button> */}
                <div className="text-left d-flex flex-column align-items-start justify-content-start">
                  <h2 className="usb-hero-heading">
                    Our Money Transfer Ecosystem
                    <br /> <p style={{ fontSize: "22px" }}>Redefining Cross-Border Transactions</p>
                  </h2>
                </div>
              </div>
              <div>
                {/* <p className="">
                  Our innovative stablecoin, USB, is designed to provide
                  financial freedom <br /> without reliance on traditional
                  banks. Built for stability, scalability, and <br /> seamless
                  integration into your ecosystem.
                </p> */}
              </div>
              <div>
                <img style={{ width: '100%' }} src="/images/Stabolutmockup_5 1.png" />
              </div>
            </div>
          </div>

          <div className="col-xl-6">
            <div className="row cards-container">
              <div className="col-lg-6 mb-3">
                <div
                  className="cards small-card"
                  data-aos="fade-right"
                  data-aos-delay="200"

                >
                  <h3 style={{ alignSelf: "flex-start" }}>
                    <img className="img-hov" src="/images/svg 01.svg" />
                  </h3>
                  <p className="color-cl" style={{ alignSelf: "flex-start", fontSize: 22 }} >
                    PEER-TO-PEER GASLESS TRANSFERS
                  </p>
                  {/* <p style={{ alignSelf: "flex-start",color:'white' }} 
                  >
                    Our innovative stablecoin, USB, is designed to provide
                    financial
                  </p> */}
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div
                  className="cards small-card "
                  data-aos="fade-left"
                  data-aos-delay="200"
                >
                  <h3 style={{ alignSelf: "flex-start" }}>
                    <img className="img-hov" src="/images/svg 02.svg" />
                  </h3>
                  <p className="color-cl" style={{ alignSelf: "flex-start", fontSize: 22 }}>
                    INSTANT CURRENCY EXCHANGE
                  </p>
                  {/* <p className="color-cl" style={{ alignSelf: "flex-start" }}>
                    Our innovative stablecoin, USB, is designed to provide
                    financial
                  </p> */}
                </div>
              </div>{" "}
              <div className="col-lg-6 mb-3">
                <div
                  className="cards small-card "
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <h3 style={{ alignSelf: "flex-start" }}>
                    <img className="img-hov" src="/images/svg 03.svg" />
                  </h3>
                  <p className="color-cl" style={{ alignSelf: "flex-start", fontSize: 22 }}>
                    DEBIT CARD
                  </p>
                  {/* <p style={{ alignSelf: "flex-start" }} className="color-cl">
                    Our innovative stablecoin, USB, is designed to provide
                    financial
                  </p> */}
                </div>
              </div>{" "}
              <div className="col-lg-6 mb-3">
                <div
                  className="cards small-card "
                  data-aos="fade-left"
                  data-aos-delay="200"
                >
                  <h3 style={{ alignSelf: "flex-start" }}>
                    <img className="img-hov" src="/images/svg 04.svg" />
                  </h3>
                  <p style={{ alignSelf: "flex-start", fontSize: 22 }} className="color-cl">
                  GLOBAL PAYMENTS ECOSYSTEM{" "}
                  </p>
                  {/* <p  style={{ alignSelf: "flex-start" }} className="color-cl">
                  Our innovative stablecoin, USB, is designed to provide financial
                  </p> */}
                </div>
              </div>{" "}
              <div className="col-lg-6 mb-3">
                <div
                  className="cards small-card "
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <h3 style={{ alignSelf: "flex-start" }}>
                    <img className="img-hov" src="/images/svg 05.svg" />
                  </h3>

                  <p style={{ alignSelf: "flex-start", fontSize: 22 }} className="color-cl">
                    PRIVACY-FIRST FINANCE
                  </p>
                  {/* <p style={{ alignSelf: "flex-start" }} className="color-cl">
                  Our innovative stablecoin, USB, is designed to provide financial
                  </p> */}
                </div>
              </div>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
